import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import ErrorIcon from '@mui/icons-material/Error';
import classNames from 'classnames';

class FeedbackModal extends React.Component {
  initialMessage = (filename, reason) => `Error processing file ${filename}. ${reason}`

  state = {
    open: false,
    vertical: 'bottom',
    horizontal: 'center',
    message: this.initialMessage,
    filename: ""
  };

  handleClick = state => () => {
    this.setState({ open: true, ...state });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  open = (filename, reason = "") => {
    let message = () => this.initialMessage(filename, reason);
    this.setState({ open: true, filename, message });
  };

  render() {
    const { className } = this.props;
    const { vertical, horizontal, open, message, filename } = this.state;
    return (
      <Snackbar className={classNames("error", "message", className)}
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={<React.Fragment><ErrorIcon className={classNames("iconVariant")} /><span id="message-id">{message(filename)}</span></React.Fragment>}
      />
    );
  }
}

export default FeedbackModal;